<template>
  <div class="modern-about page-theme page-theme--sage">
    <page-stripes side="left" :colors="stripeColors" />
    <section class="hero container">
      <div class="hero__copy">
        <p class="eyebrow">ABOUT INTERIO</p>
        <h1>共創でプロダクトを磨きあげるチーム</h1>
        <p>
          2008年の創業以来、インタリオ株式会社は UI
          設計とエンジニアリングをつなぐ実践知を蓄積してきました。 kokono
          スイートによって、仕様設計からフィードバック、採用に至るまで統一された体験を提供しています。
        </p>
      </div>
      <div class="hero__card">
        <p>拠点</p>
        <h3>埼玉県蕨市 / 東京</h3>
        <p>事業領域</p>
        <h3>UI 設計 / コラボレーション SaaS / HR Tech</h3>
      </div>
    </section>

    <section class="section container">
      <div class="section__header">
        <p class="eyebrow">COMPANY</p>
        <h2>会社概要</h2>
      </div>
      <div class="company-table-wrapper">
        <table class="company-table">
          <tbody>
            <tr v-for="item in company" :key="item.title">
              <th>{{ item.title }}</th>
              <td>{{ item.desc }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="section container">
      <div class="section__header">
        <p class="eyebrow">HISTORY</p>
        <h2>沿革ダイジェスト</h2>
      </div>
      <div class="timeline">
        <div class="timeline__item" v-for="item in history" :key="item.year">
          <p class="year">{{ item.year }}</p>
          <div>
            <p class="title">{{ item.title }}</p>
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section section--dark">
      <div class="container values">
        <div class="section__header">
          <p class="eyebrow">VALUES</p>
          <h2>働き方とカルチャー</h2>
        </div>
        <div class="values__grid">
          <article v-for="item in values" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <section class="next-step">
      <div class="container">
        <div class="next-step__card">
          <div class="next-step__copy">
            <p class="eyebrow">NEXT STEP</p>
            <h2>kokono スイートの詳細と導入をご希望ですか？</h2>
            <p>
              最新のサービスページは
              <router-link to="/services" class="inline-link">こちら</router-link>
              からご確認いただけます。
            </p>
          </div>
          <router-link class="btn primary" to="/next-contact"
            >問い合わせへ</router-link
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref } from "vue";
import PageStripes from "../components/PageStripes.vue";

export default {
  name: "ModernAbout",
  components: {
    PageStripes,
  },
  setup() {
    const stripeColors = ["#e8f5e9", "#c8e6c9", "#a5d6a7", "#81c784"];
    const company = ref([
      { title: "社名", desc: "インタリオ株式会社" },
      { title: "資本金", desc: "5,120,000円" },
      /*
      { title: "代表", desc: "石塚 亘" }, 
       */
      { title: "所在地", desc: "埼玉県蕨市北町1-25-12" },
      { title: "設立", desc: "2008年12月" },
      { title: "取引銀行", desc: "三菱UFJ銀行 / PayPay銀行" },
    ]);

    const history = ref([
      {
        year: "2008",
        title: "創業",
        desc: "受託開発と UI コンサルティングを開始",
      },
      {
        year: "2012",
        title: "fastFix リリース",
        desc: "スクラム開発向けタスク・レトロ管理ツールを公開",
      },
      {
        year: "2016",
        title: "kokono pro α",
        desc: "UI 仕様書生成ツールの社内版をローンチ",
      },
      {
        year: "2024",
        title: "kokono lite",
        desc: "画像コメント SaaS を正式リリース",
      },
      {
        year: "2024",
        title: "kokono pro α",
        desc: "UI仕様書 KOKONO Proを正式リリース",
      },
      {
        year: "2025",
        title: "kokono cv",
        desc: "履歴書ビルダーと HR Tech に領域拡大",
      },
    ]);

    const values = ref([
      {
        title: "Transparency",
        desc: "ドキュメント中心の文化で、全員が意思決定背景まで共有。",
      },
      {
        title: "DesignOps",
        desc: "UI とビジネス要件を結ぶオペレーションを重視し、品質とスピードを両立。",
      },
      {
        title: "Remote Native",
        desc: "国内外のメンバーとリモートで協業し、タイムゾーンを跨いだ開発に対応。",
      },
    ]);

    return {
      stripeColors,
      company,
      history,
      values,
    };
  },
};
</script>

<style lang="scss" scoped>
.modern-about {
  background: #ffffff;
  color: #1e293b;
  min-height: 100vh;
  position: relative;
  z-index: 1;
}

.container {
  width: min(1180px, 92vw);
  margin: 0 auto;
}

.hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 5rem 0 3rem;
}

.hero__card {
  background: var(--theme-bg-alt);
  border: 1px solid var(--theme-accent-pale);
  border-left: 3px solid var(--theme-accent-light);
  border-radius: 24px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.hero__card h3 {
  color: #1e293b;
}

.hero__card p {
  color: #64748b;
}

.hero__copy p {
  color: #64748b;
}

.eyebrow {
  letter-spacing: 0.4em;
  font-size: 0.8rem;
  color: var(--theme-accent);
}

.hero__copy h1 {
  font-size: clamp(2.6rem, 4vw, 4rem);
  margin: 1rem 0;
  color: #1e293b;
}

.section {
  padding: 4rem 0;
}

.section__header {
  margin-bottom: 1.5rem;
}

.section__header h2 {
  color: #1e293b;
}

.company-table-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-top: 3px solid var(--theme-accent-light);
  border-radius: 18px;
  padding: 1.5rem;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.company-table {
  width: 100%;
  border-collapse: collapse;
}

.company-table th {
  text-transform: none;
  font-size: 0.95rem;
  letter-spacing: 0.05em;
  color: #64748b;
  padding: 0.9rem;
  text-align: left;
  width: 180px;
  border-bottom: 1px solid #e2e8f0;
}

.company-table td {
  padding: 0.9rem;
  font-size: 1.1rem;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}

.company-table tr:last-child th,
.company-table tr:last-child td {
  border-bottom: none;
}

.timeline {
  border-left: 2px solid var(--theme-accent-light);
  margin-left: 1rem;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.timeline__item {
  position: relative;
}

.timeline__item::before {
  content: "";
  position: absolute;
  left: -1.5rem;
  top: 0.4rem;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--theme-accent);
}

.timeline .year {
  font-weight: 700;
  color: var(--theme-accent);
}

.timeline .title {
  color: #1e293b;
  font-weight: 600;
}

.timeline .desc {
  color: #64748b;
}

.section--dark {
  background: var(--theme-bg-alt);
  border-top: 1px solid var(--theme-accent-pale);
  border-bottom: 1px solid var(--theme-accent-pale);
}

.values__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.values__grid article {
  background: #ffffff;
  border-radius: 20px;
  padding: 1.8rem;
  border: 1px solid #e2e8f0;
  border-left: 3px solid var(--theme-accent-light);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.values__grid article h3 {
  color: #1e293b;
}

.values__grid article p {
  color: #64748b;
}

.next-step {
  padding: 4rem 0;
}

.next-step__card {
  background: var(--theme-bg-alt);
  border: 1px solid var(--theme-accent-pale);
  border-left: 3px solid var(--theme-accent-light);
  border-radius: 24px;
  padding: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.next-step__copy h2 {
  color: #1e293b;
  margin: 0.75rem 0 1rem;
}

.next-step__copy p {
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

.btn {
  border-radius: 999px;
  padding: 0.9rem 1.8rem;
  text-decoration: none;
  color: var(--theme-btn-text);
  background: linear-gradient(
    120deg,
    var(--theme-accent-light),
    var(--theme-accent)
  );
  font-weight: 600;
}

.inline-link {
  font-weight: 600;
  color: var(--theme-accent);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--theme-accent-mid);
  }
}

@media (max-width: 768px) {
  .timeline {
    margin-left: 0;
    border-left: none;
  }

  .timeline__item::before {
    display: none;
  }

  .next-step__card {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
